// extracted by mini-css-extract-plugin
export var container = "DepositContent-module--container--b7f14";